import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
// libraries
import { Grid, Dialog, Container, Stack, Button, Box, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../Iconify';
import { Archive } from '../tabs';
import { Transition } from '.';
// styles
import {
    reminderDialogStyle,
    reminderStackStyle,
    reminderFooterStyle,
    cancelButtonStyle,
    saveButtonStyle
} from '../../styles/AddReminderPopup';

const ArchivedLeadPopUp = ({ open, onClose, user, isDuplicate, setForceUpdate, onExplicitArchiveSubmit }) => {
    const inputRef = useRef();
    // Tracks in-flight submission to disable the Archive button.
    // Prevents rapid double-click at the UI level (Archive.jsx's submittingRef
    // is the synchronous backstop; this drives the disabled state for UX).
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!user) return null;

    const handleNext = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            await inputRef.current.submit('finish');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Dialog
            TransitionComponent={Transition}
            open={open}
            sx={reminderDialogStyle}
        >
            <Stack sx={reminderStackStyle}>
                <Grid container spacing={1} sx={{ margin: 'auto', width: '100%' }}>
                    <Container maxWidth={'xl'} sx={{ padding: '0 !important' }}>
                        <Typography variant='h5' sx={{ fontSize: '18px' }} > Archive <span style={{ textTransform: 'capitalize' }}>{user.first_name || ''} {user.last_name || ''}</span></Typography>
                        {user?.treatment_name && (
                            <Typography sx={{ fontSize: 13, color: 'text.secondary', mt: 1, textAlign: 'center' }}>
                                Treatment: <b>{user.treatment_name}</b>{user?.status ? ` · ${String(user.status).replace(/_/g, ' ')}` : ''}
                            </Typography>
                        )}
                        <Archive
                            user={user}
                            ref={inputRef}
                            isDuplicate={isDuplicate}
                            handleClose={onClose}
                            setForceUpdate={setForceUpdate}
                            onExplicitArchiveSubmit={onExplicitArchiveSubmit}
                        />
                    </Container>
                </Grid>
            </Stack>
            <Box sx={reminderFooterStyle}>
                <Button
                    color='inherit'
                    sx={cancelButtonStyle}
                    disabled={isSubmitting}
                    onClick={() => onClose(true)}
                >
                    Cancel
                </Button>
                <LoadingButton
                    color='error'
                    variant='contained'
                    onClick={handleNext}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    loadingPosition="start"
                    sx={saveButtonStyle}
                    startIcon={<Iconify icon={'eva:archive-fill'} />}
                >
                    {isSubmitting ? 'Archiving...' : 'Archive'}
                </LoadingButton>
            </Box>
        </Dialog>
    );
};

export default ArchivedLeadPopUp;

ArchivedLeadPopUp.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    user: PropTypes.object,
    isDuplicate: PropTypes.bool,
    setForceUpdate: PropTypes.func,
    onExplicitArchiveSubmit: PropTypes.func
};
